export const formatDate = (timestamp: number) =>  {
    const date = new Date(timestamp * 1000);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}  


export const suggestModelName = (
  originalName: string,
  existingNames: string[]
): string => {
  let suggestedName = `Copy of ${originalName}`;
  if (!existingNames.includes(suggestedName)) {
    return suggestedName;
  }
  let counter = 1;
  while (existingNames.includes(`${suggestedName} (${counter})`)) {
    counter++;
  }
  return `${suggestedName} (${counter})`;
};